export default __webpack_public_path__ + "static/media/instagram_logo.66f2d958.svg";